<template>
  <div class="unit-cost">
    <div class="top">
      <a href="#/ApprovalIndex">
        <img src="../assets/images/adidas.png" style="width: 160px; height: 37px; margin-top: 10px" />
      </a>
      <a href="#/ApprovalIndex" style="margin-top: 10px; margin-left: 30px; float: left">
        <img src="../assets/icon/back2.png" />
      </a>
    </div>
    <div class="cost-filter">
      <label style="color: #606266; font-size: 14px">Channel</label>
      <el-select
        v-model="Channels"
        multiple
        collapse-tags
        placeholder="Please select"
        style="margin-left: 5px; flex: 1"
        @change="GetSubChannel"
      >
        <el-checkbox
          v-model="check_Channels"
          style="margin-left: 20px; width: 200px"
          :indeterminate="Channels.length !== ChannelOptions.length"
          @change="selectAll_Channels"
        >All</el-checkbox>
        <el-option v-for="item in ChannelOptions" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <label style="margin-left: 10px; color: #606266; font-size: 14px">Sub Channel</label>
      <el-select
        v-model="SubChannels"
        multiple
        collapse-tags
        placeholder="Please select"
        style="margin-left: 5px; flex: 1"
        @change="GetFormat"
      >
        <el-checkbox
          v-model="check_SubChannels"
          style="margin-left: 20px; width: 200px"
          :indeterminate="SubChannels.length != SubChannelOptions.length"
          @change="selectAll_SubChannels"
        >All</el-checkbox>
        <el-option v-for="item in SubChannelOptions" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <label style="margin-left: 10px; color: #606266; font-size: 14px">Format</label>
      <el-select
        v-model="Formats"
        multiple
        collapse-tags
        placeholder="Please select"
        style="margin-left: 5px; flex: 1"
      >
        <el-checkbox
          v-model="check_Formats"
          style="margin-left: 20px; width: 200px"
          :indeterminate="Formats.length !== FormatOptions.length"
          @change="selectAll_Formats"
        >All</el-checkbox>
        <el-option v-for="item in FormatOptions" :key="item" :label="item" :value="item"></el-option>
      </el-select>
      <!-- <label style="margin-left: 10px; color: #606266; font-size: 14px;display:none;">Support Scheme</label>
      <el-select
        v-model="supportScheme"
        clearable
        placeholder="Please Choose"
        style="margin-left: 10px;display:none;"
      >
        <el-option v-for="item in supportScheme" :key="item" :label="item" :value="item"></el-option>
      </el-select> -->
    </div>
    <div class="cost-btn cost-filter">
      <el-button class="button-search" @click="BindData(1)">Search</el-button>
      <el-button class="button-search" @click="Import()">Import</el-button>
      <el-button class="button-search" @click="Export('List')">Export</el-button>
    </div>
    <div class="content_title">
      <div class="div-pagination">
        <el-pagination
          background
          @current-change="pagingChange"
          :current-page.sync="currentPage"
          @size-change="handleSizeChange"
          :page-size="pagenum"
          :page-sizes="[20,30,50, 100]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          ref="multipleTable"
        ></el-pagination>
      </div>
      <div class="table" ref="table">
        <el-table
          ref="multipleTable"
          v-loading="loading"
          @current-change="handleCurrentChange"
          :data="tableData"
          :header-cell-style="tableHeaderCell"
          :cell-style="tableCell"
          :height="tableHeight"
          border
        >
          <template v-if="tableColumn.length > 0">
            <el-table-column
              v-for="(item, index) in tableColumn"
              :key="index"
              :prop="item.value"
              :label="item.label"
              :width="flexColumnWidth(item.label, item.value)"
              :fixed="getIsFixed(index)"
            >
              <template slot-scope="scope">
                <span
                  :class="item.value === 'Format' ? 'edit-row' : ''"
                  @click="editUnit(scope.row, item.value)"
                >{{ transferToDecimal(scope.row[item.value]) }}</span>
              </template>
              <template slot="header">
                <div v-html="formatterStr(item.label)"></div>
              </template>
            </el-table-column>
          </template>
        </el-table>
      </div>
      <el-dialog title="Upload File" :visible.sync="dialogUploadVisible" width="50%" :close-on-click-modal="false"
          :destroy-on-close="true" @close="Close" style="text-align:left;">
          <div style="float: left" size="mini">
              <el-upload class="upload-demo" ref="upload" :multiple="false" :file-list="filelist" :limit="2" action
                  :http-request="requestFile" :on-change="handleChange" accept=".xlsx" :auto-upload="false">
                  <el-button slot="trigger" size="mini" type="primary">Choose File</el-button>
                  <el-button style="margin-left: 10px" size="mini" type="success" @click="submitUpload">Upload</el-button>
                  
                  <el-button size="mini" style="margin-left: 10px" class="btn" @click="Export('Template')" type="primary">
                      Download Template</el-button> 
                 <el-link v-if="errShow" style="margin-left: 10px;" size="mini" type="danger"
                      @click.native="Export('Error')">下载错误文件</el-link> 
                  <!-- <el-input v-if="resultShow" type="textarea" autosize placeholder="Result:" v-model="textarea" style="width: 25%"></el-input> -->
              </el-upload>
          </div>
          <span slot="footer" class="dialog-footer">
              <el-button size="mini" @click="Close">Cancel</el-button>
          </span>
      </el-dialog>
    </div>    
  </div>
</template>

<script>
import Download from "@/common/js/Download.js";
export default {
  data() {
    return {
      ChannelOptions: [],
      Channels: [],
      SubChannelOptions: [],
      SubChannels: [],
      FormatOptions: [],
      Formats: [],
      //supportScheme: "",
      //supportSchemes: ["A", "F", "X", "D"],
      tableData: [],
      tableColumn: [
        {
          label: "Format",
          value: "format"
        }
      ],
      total: 0,
      loading: false,
      currentPage: 1,
      pagenum: 20,
      tableHeight: window.innerHeight - 230,
      filelist:[],
      dialogUploadVisible:false,
      errShow:false
    };
  },
  computed: {
    check_Channels: {
      get() {
        if (this.Channels.length === this.ChannelOptions.length) {
          return true;
        }
        return false;
      },
      set() {}
    },
    check_SubChannels: {
      get() {
        if (this.SubChannels.length === this.SubChannelOptions.length) {
          return true;
        }
        return false;
      },
      set() {}
    },
    check_Formats: {
      get() {
        if (this.Formats.length === this.FormatOptions.length) {
          return true;
        }
        return false;
      },
      set() {}
    }
  },
  methods: {
    tableHeaderCell() {
      return "background: #FFEDD1;color: #5A5854;text-align: center;";
    },
    tableCell() {
      return "background: #FFFFFF;color: #5A5854;text-align: center;";
    },
    getTextWidth(str) {
      let width = 0;
      const html = document.createElement("span");
      html.innerText = str;
      html.className = "getTextWidth";
      document.querySelector("body").appendChild(html);
      width = document.querySelector(".getTextWidth").offsetWidth;
      document.querySelector(".getTextWidth").remove();
      return width;
    },
    flexColumnWidth(label, prop) {
      if (this.tableData.length > 0) {
        const arr = this.tableData.map(x => x[prop]);
        arr.push(label);
        return this.getMaxLength(arr) + 20 + "px";
      } else {
        return "auto";
      }
    },
    getMaxLength(arr) {
      return arr.reduce((acc, item) => {
        if (item) {
          let c = this.getTextWidth(item);
          if (acc < c) {
            acc = c;
          }
        }
        return acc;
      }, 0);
    },
    getWidth(column) {
      console.log(column);
      return 9 * column.length + 10 + "px";
    },
    getIsFixed(index) {
      if (index > 0) {
        return false;
      } else {
        return true;
      }
    },
    pagingChange(pageIndex) {
      this.BindData(pageIndex);
    },
    handleSizeChange(val) {
      this.pagenum = val;
      this.BindData(this.currentPage);
    },
    handleCurrentChange(row) {
      this.currentRow = row;
    },
    async GetCRFormatCostColumns() {
      await this.$api.get("/CR/GetCRFormatCostColumns/", {}).then(res => {
        if (res.data.status == true) {
          var columns = res.data.content;
          if (columns != null && columns.length > 0) {
            columns.forEach(element => {
              // element.label = element.label.replace('\\n','<br>')
              this.tableColumn.push(element);
            });
          }
        } else {
          if (res.data.message == "Login Error") {
            this.$router.push({ path: "/" });
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            });
            return false;
          }
        }
      });
      await this.BindData(1);
    },
    async BindData(pageIndex) {
      this.tableData = [];
      this.tableHeight = window.innerHeight - 230;
      this.currentPage = pageIndex;
      this.loading = true;
      await this.$api
        .get("/CR/GetPLMCRFormatCost/", {
          currentpage: pageIndex,
          pagenum: this.pagenum,
          channel:this.Channels.join(),
          subChannel:this.SubChannels.join(),
          format:this.Formats.join()
        })
        .then(res => {
          if (res.data.status == true) {
            //if (res.data.content.length > 0) {
              // res.data.content.sort((a, b) => {
              //   return a.oldFormat - b.oldFormat;
              // });
            //}/
            this.tableData = res.data.content;
            this.total = res.data.total;
            this.$nextTick(()=>{
              this.$refs.multipleTable.doLayout();
            })
          } else {
            if (res.data.message == "Login Error") {
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.message
              });
              this.loading = false;
              return false;
            }
          }
          this.loading = false;
        });
    },
    transferToDecimal(cellvalues) {
      //if (!!cellvalues && typeof cellvalues === "number") {
        if (typeof cellvalues == "number") {
          cellvalues = parseFloat(cellvalues).toFixed(2);
          let [sInt, sFloat] = cellvalues.toString().split(".");
          sInt = sInt.replace(/\d(?=(\d{3})+$)/g, "$&,");
          return (cellvalues = sFloat ? `${sInt}.${sFloat}` : `${sInt}`);
        //}
      } else {
        return cellvalues;
      }
    },
    formatterStr(str) {
      return str.toString().replace("\\n", "<br>");
    },
    editUnit(row, colomn) {
      if (colomn === "Format") {
        this.$router.push({
          name: "UnitCostMaintananceEdit"
          // params: { ID: row },
        });
      } else {
        return;
      }
    },
    AddNewCategory() {
      this.$router.push({
        name: "CategoryMaintanance"
        // params: { ID: row },
      });
    },
    labelFn() {
      return "供应商\n所属国家";
    },
    GetChannel() {
      this.$api
        .get("/Task/GetChannel", {}, res => {})
        .then(res => {
          if (res.data.status) {
            this.ChannelOptions = res.data.content;
          } else {
            this.$message({
              type: "error",
              message: res.data.message
            });
            return false;
          }
        })
        .then(() => {
          this.$refs.multipleTable.doLayout();
        });
        
        // this.$nextTick(()=>{
        //    this.$refs.multipleTable.doLayout();
        // })
    },
    GetSubChannel() {
      if (this.Channels.length > 0) {
        this.$api
          .post("/Task/GetSubChannel", { strs: this.Channels }, res => {})
          .then(res => {
            if (res.data.status) {
              this.SubChannelOptions = res.data.content;
            } else {
              this.$message({
                type: "error",
                message: res.data.message
              });
              return false;
            }
          });
      } else {
        this.SubChannelOptions = [];
        this.SubChannels = [];
      }
    },
    GetFormat() {
      if (this.SubChannels.length > 0) {
        this.$api
          .post("/Task/GetFormat", { strs: this.SubChannels }, res => {})
          .then(res => {
            if (res.data.status) {
              this.FormatOptions = res.data.content;
            } else {
              this.$message({
                type: "error",
                message: res.data.message
              });
              return false;
            }
          });
      } else {
        this.FormatOptions = [];
      }
    },
    selectAll_Channels(checked) {
      if (checked) {
        this.Channels = this.ChannelOptions.map(d => d);
      } else {
        this.Channels = [];
      }
      this.GetSubChannel();
    },
    selectAll_SubChannels(checked) {
      if (checked) {
        this.SubChannels = this.SubChannelOptions.map(d => d);
      } else {
        this.SubChannels = [];
      }
      this.GetFormat();
    },
    selectAll_Formats(checked) {
      if (checked) {
        this.Formats = this.FormatOptions.map(d => d);
      } else {
        this.Formats = [];
      }
    },
    Export(type){
      this.$api
        .get("/CR/GetUnitCostExport",{
          channel:this.Channels.join(),
          subChannel:this.SubChannels.join(),
          format:this.Formats.join(),
          type:type
          },"arraybuffer")
        .then((res) => {
          if(res.status=="200")
          {
            let fileName= res.headers['content-disposition'].split("attachment; filename=")[1];  
            fileName=fileName.split(";")[0];      
            Download(res.data, fileName);
           // loading.close();
          } else {
              this.$message({ message: res.data.message, type: "warring" });
             // loading.close();
          }
        });
      },
    Import() {
      this.dialogUploadVisible = true;
    },
    submitUpload() {
      var files = this.$refs.upload.uploadFiles;
      if (files == 0) {
          return this.$message({
              message: 'Please choose a file',
              type: 'error',
          });
      } else {
          this.$refs.upload.submit();
      }
    },
    requestFile(param) {           
      var _this = this;
      _this.$refs.upload.clearFiles();
      var fileObj = param.file;
      var formData = new FormData(); // FormData 对象
      formData.append('file', fileObj);
      this.$api.post("/CR/ImportUnitCost",formData, { responseType: 'blob' }, { headers: { 'Content-Type': 'multipart/form-data',"Access-Control-Allow-Origin": "*" } }
      ).then(res=>{
          if(res.data.status)
          {
            this.$message({
              type: "success",
              message: res.data.message
            });
            this.dialogUploadVisible=false;
            this.BindData(1);
          }else{
            if(res.data.message!="模板不对")
              this.errShow=true;
            else
              this.errShow=false;
            this.$message({
              type: "error",
              message: res.data.message
            });
          }
        },err =>{
          this.$message({
              type: "error",
              message: res.data.message
            });
        });    
    },
    handleChange(file,filelist)
    {
      const newfile=filelist.slice(-1);
      this.filelist=newfile;
    },
    Close(){
      this.dialogUploadVisible=false;
      this.filelist=[];
      this.errShow=false;      
    },  
  },
  mounted() {
    this.GetCRFormatCostColumns();
    // this.BindData(1);
    this.$nextTick(() => {
      this.GetChannel();
    });
  }
};
</script>

<style scoped lang="scss">
.top {
  height: 60px;
  background: #232b33;
  color: white;
  text-align: center;
  line-height: 50px;
}
.cost-filter {
  text-align: left;
  display: flex;
  align-items: center;
  margin: 0 5%;
  margin-top: 10px;
}
.cost-btn {
  margin-top: 15px;
  .button-search {
    background-color: #e6a23c;
    border: 0px #e6a23c;
    color: #ffff;
  }
}
.content_title {
  margin: auto;
  width: 90%;
  text-align: center;
  .table {
    min-height: 200px;
  }
}
.div-pagination {
  text-align: right;
  margin-bottom: 10px;
}
.edit-row {
  text-decoration: underline;
  color: #409eff;
  cursor: pointer;
}
</style>
<style>
.el-table .cell,
.el-table th {
  padding-left: 0px !important;
  padding-right: 0px !important;
}
.el-table .cell,
.el-table--border td:first-child .cell,
.el-table--border th:first-child .cell {
  padding: 0px !important;
}
.el-select-dropdown__wrap {
  max-height: 400px !important;
}
.el-table th.el-table__cell > .cell {
  white-space: pre;
}

</style>


// WEBPACK FOOTER //
// src/components/UnitCostMaintanance.vue